import type { ResultOf } from '@graphql-typed-document-node/core'
import type { RestaurantArea } from '~/components/area/restaurantArea.frag'
import type { RestaurantGenre } from '~/components/genre/restaurantGenre.frag'
import type { Breadcrumb } from '~/ui/Breadcrumbs'
import { prefectureDisplayName } from '../prefecture/prefecture'

export function buildRestaurantBreadcrumbs(
  restaurantName: string,
  restaurantId: string,
  area: ResultOf<typeof RestaurantArea>['area'],
  genre: ResultOf<typeof RestaurantGenre>['genre'],
  clientNavigation: boolean,
  planName?: string
): Breadcrumb[] {
  const mediumDisplayName = prefectureDisplayName(area.mediumName)
  const breadcrumbs: Breadcrumb[] = [
    {
      label: 'レストラントップ',
      href: '/',
    },
    // mediumArea
    {
      label: `${mediumDisplayName}のレストラン`,
      href: `/area/${area.mediumKey}/`,
      clientNavigation,
    },
    // mediumArea + minorGenre
    {
      label: `${mediumDisplayName} ${genre.minor.name}`,
      href: `/area/${area.mediumKey}/${genre.minor.code}/`,
      clientNavigation,
    },
  ]

  // smallArea + minorGenre
  if (area.smallName !== mediumDisplayName) {
    breadcrumbs.push({
      label: `${area.smallName} ${genre.minor.name}`,
      href: `/area/${area.mediumKey}/${area.smallCode}/${genre.minor.code}/`,
      clientNavigation,
    })
  }

  // minArea + minorGenre
  if (area.minimums.length > 0) {
    breadcrumbs.push({
      label: `${area.minimums[0].name} ${genre.minor.name}`,
      href: `/area/${area.mediumKey}/${area.smallCode}/${area.minimums[0].code}/${genre.minor.code}/`,
      clientNavigation,
    })
  }

  if (planName) {
    // restaurant
    breadcrumbs.push({
      label: restaurantName,
      href: `/${restaurantId}`,
      clientNavigation: true,
    })
    // plan
    breadcrumbs.push({
      label: planName,
    })
    return breadcrumbs
  }

  // restaurant
  breadcrumbs.push({
    label: restaurantName,
  })
  return breadcrumbs
}
